module.exports = __webpack_public_path__ + "static/img/tips.12de33c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/traffic/tips.png
// module id = NgSU
// module chunks = 1